const PageNotFound = (): JSX.Element => <h1>Page not found.</h1>;

export default PageNotFound;